import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m1.6 8.212 10 4.888c.1.098.2.098.4.098s.3 0 .4-.098l10-4.888q.6-.293.6-.88 0-.586-.6-.88l-10-4.887q-.45-.147-.9 0l-10 4.887c-.3.196-.5.49-.5.88q0 .587.6.88M12 3.52l7.8 3.812-7.8 3.813-7.8-3.813zm9.6 12.708L12 20.921l-9.6-4.693c-.5-.195-1.1 0-1.3.391s0 1.076.4 1.271l10 4.888c.2.196.3.196.5.196s.3 0 .4-.098l10-4.888c.5-.196.7-.782.4-1.271-.2-.489-.8-.684-1.2-.489m0-4.888L12 16.033 2.4 11.34c-.5-.195-1.1 0-1.3.391-.2.49 0 1.076.4 1.271l10 4.888c.2.196.3.196.5.196s.3 0 .4-.098l10-4.888c.5-.195.7-.782.4-1.27-.2-.49-.8-.685-1.2-.49"
    }, null, -1)
  ]))]))
}
export default { render: render }